import { render, staticRenderFns } from "./NeedsToSign.vue?vue&type=template&id=7a59b2ce&"
import script from "./NeedsToSign.vue?vue&type=script&lang=js&"
export * from "./NeedsToSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports